import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_ScenarioPlanner_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_SCNPLANNER_ID:          {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Id',                  alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_MDSET_ID:               {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'wbMdSetId',              alignment: HorizAlignment.Left},  domainOptions: {} },
    MDSET_ID:                  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'MD Set Id',              alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MDSET_NAME:                {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Master Data Set',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    WB_SALESORG_ID:            {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'wbSalesOrgId',           alignment: HorizAlignment.Left},  domainOptions: {} },
    SALESORG_ID:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'SalesOrg Id',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SALESORG_NAME:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Sales Org',              alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    WB_PUBLISHED_MODEL_ID:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'wbPublishedModelId',     alignment: HorizAlignment.Left},  domainOptions: {} },
    PLANNER_ID:                {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Id',                     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PLANNER_NAME:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Name',                   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    PUBLISHED_MODEL_ID:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Published Model Id',     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PUBLISHED_MODEL_NAME:      {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Published Model',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    ENTITY_ID_CUSTOMER:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Entity Id',     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ENTITY_NAME_CUSTOMER:      {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Entity',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    ENTITY_ID_PRODUCT:         {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Entity Id',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ENTITY_NAME_PRODUCT:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Entity',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    ENTITY_ID_PERIOD:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Time Entity Id',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ENTITY_NAME_PERIOD:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Time Entity',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    WB_TREE_FOLDER_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'wbTreeFolderId',         alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_AUTHUSR_ID_CREATEDBY:   {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'wbAuthUsrIdCreatedBy',   alignment: HorizAlignment.Left},  domainOptions: {} },
    AUTHUSR_EMAIL:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Created By',             alignment: HorizAlignment.Left},  domainOptions: {} },

};

const ScenarioPlannerSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_SCNPLANNER_ID',
        id_ui: 'PLANNER_ID',
        name:  'PLANNER_NAME'
    },

    searchProviderFields: vUI_ScenarioPlanner_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Scenario_Planner_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ScenarioPlannerSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ScenarioPlannerSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'PLANNER_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PLANNER_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'PLANNER_ID', 'PLANNER_NAME',
        'PUBLISHED_MODEL_NAME', 'ENTITY_NAME_CUSTOMER', 'ENTITY_NAME_PRODUCT', 'ENTITY_NAME_PERIOD',
        'AUTHUSR_EMAIL', 'SALESORG_NAME', 'SHARED_IND'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ScenarioPlannerSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


const ScenarioPlannerSearch: ISearch = {
    searchName: "Find Scenario Plan",
    renderOptions: {ui5ResourceId: "ScenarioPlannerSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ScenarioPlannerSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("ScenarioPlannerBO", "ScenarioPlanner", ScenarioPlannerSearch, "Scenario Planner Search")

export {ScenarioPlannerSearch}

